var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgPrivate = function SvgPrivate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "private_svg__Layer_2_00000023970913532060465590000012671007801236833927_",
    x: 0,
    y: 0,
    viewBox: "0 0 139.4 27",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".private_svg__st1{enable-background:new}.private_svg__st2{fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "private_svg__Main_content"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ec6c68",
    d: "M0 0h139.4v27H0z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "private_svg__st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "private_svg__st2",
    d: "M45.3 12.4c0 1.8-1.3 2.9-3.4 2.9h-2.3V18h-.9V9.5h3.1c2.2 0 3.5 1.1 3.5 2.9zm-.9 0c0-1.3-.9-2.1-2.6-2.1h-2.2v4.2h2.2c1.7 0 2.6-.8 2.6-2.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "private_svg__st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "private_svg__st2",
    d: "M50.3 11.6v.8h-.2c-1.3 0-2.1.8-2.1 2.3v3.2h-.9v-6.3h.8v1.2c.4-.8 1.2-1.2 2.4-1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "private_svg__st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "private_svg__st2",
    d: "M51.9 9.6c0-.3.3-.6.6-.6s.6.3.6.6-.3.6-.6.6-.6-.2-.6-.6zm.2 2h.9v6.3h-.9v-6.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "private_svg__st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "private_svg__st2",
    d: "M60.8 11.6L58 17.9h-.9l-2.8-6.3h.9l2.4 5.4 2.4-5.4h.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "private_svg__st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "private_svg__st2",
    d: "M66.9 14v3.9h-.8v-1c-.4.6-1.1 1-2.2 1-1.4 0-2.3-.7-2.3-1.8 0-1 .6-1.8 2.4-1.8h2V14c0-1.1-.6-1.7-1.8-1.7-.8 0-1.6.3-2.1.7l-.4-.6c.6-.5 1.6-.9 2.6-.9 1.6.1 2.6.9 2.6 2.5zm-.9 2v-1h-2c-1.2 0-1.6.5-1.6 1.1 0 .7.6 1.2 1.6 1.2s1.7-.4 2-1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "private_svg__st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "private_svg__st2",
    d: "M72.8 17.5c-.3.3-.8.4-1.3.4-1.2 0-1.8-.7-1.8-1.8v-3.8h-1.1v-.7h1.1v-1.4h.9v1.4h1.9v.7h-1.9v3.8c0 .7.4 1.2 1.1 1.2.3 0 .7-.1.9-.3l.2.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "private_svg__st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "private_svg__st2",
    d: "M79.8 15h-5.3c.1 1.3 1.1 2.2 2.5 2.2.8 0 1.5-.3 1.9-.8l.5.6c-.6.7-1.4 1-2.4 1-2 0-3.3-1.3-3.3-3.2 0-1.9 1.3-3.2 3.1-3.2s3.1 1.3 3.1 3.2c-.1 0-.1.1-.1.2zm-5.3-.6H79c-.1-1.2-1-2.1-2.2-2.1-1.3 0-2.2.9-2.3 2.1zM85.3 14.3V9.5h.9v4.8c0 2 .9 2.9 2.6 2.9 1.6 0 2.6-.9 2.6-2.9V9.5h.9v4.8c0 2.4-1.3 3.7-3.4 3.7-2.3 0-3.6-1.2-3.6-3.7zM94 17.2l.4-.7c.5.4 1.4.7 2.2.7 1.2 0 1.7-.4 1.7-1 0-1.6-4.1-.3-4.1-2.8 0-1 .9-1.8 2.5-1.8.8 0 1.7.2 2.2.6l-.4.7c-.6-.4-1.2-.5-1.9-.5-1.1 0-1.6.4-1.6 1 0 1.7 4.1.4 4.1 2.8 0 1.1-1 1.8-2.6 1.8-.9 0-1.9-.3-2.5-.8zM106.5 15h-5.3c.1 1.3 1.1 2.2 2.5 2.2.8 0 1.5-.3 1.9-.8l.5.6c-.6.7-1.4 1-2.4 1-2 0-3.3-1.3-3.3-3.2 0-1.9 1.3-3.2 3.1-3.2s3.1 1.3 3.1 3.2c-.1 0-.1.1-.1.2zm-5.3-.6h4.5c-.1-1.2-1-2.1-2.2-2.1-1.2 0-2.1.9-2.3 2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "private_svg__st2",
    d: "M16.1 15.8c0 .3-.2.6-.4.8V18c0 .2-.2.4-.4.4s-.4-.2-.4-.4v-1.4c-.3-.2-.4-.4-.4-.8 0-.5.4-.9.9-.9.3 0 .7.4.7.9zm4 3.5c0 .5-.4.9-.9.9h-7.9c-.5 0-.9-.4-.9-.9V14c0-.5.4-.9.9-.9h7.9c.5 0 .9.4.9.9v5.3zm-7.5-7v-1.7c0-1.5 1-2.7 2.6-2.7s2.7 1.2 2.7 2.7v1.7h-5.3zm6.6 0h-.4v-1.7c0-2-1.5-3.6-3.5-3.6s-3.5 1.6-3.5 3.6v1.7h-.4c-1 0-1.8.8-1.8 1.8v5.3c0 1 .8 1.8 1.8 1.8h7.9c1 0 1.8-.8 1.8-1.8V14c-.1-1-.9-1.7-1.9-1.7z"
  }))));
};

export default SvgPrivate;